<template>
  <hawk-iframe path="p/map"></hawk-iframe>
</template>
<script>

import HawkIframe from '@/components/HawkIframe.vue';

export default {
  name: 'hawk-map',
  components: {
    HawkIframe,
  },
  mounted() {
    this.$store.dispatch('SET_FULL_PAGE', true);
  },
  beforeDestroy() {
    this.$store.dispatch('SET_FULL_PAGE', false);
  },
};
</script>


// WEBPACK FOOTER //
// src/views/pages/hawk/Map.vue